import { MyTaskExecutionSection, TaskExecution } from "shared/api";
import { MyTaskExecutionRow } from "shared/types";

/**
 * Depth-first flatten of every task execution in the section tree into a single
 * list — used for the flat "Complete my tasks" table.
 */
export const flattenMyTaskExecutions = (
  node: MyTaskExecutionSection
): TaskExecution[] => [
  ...(node.task_executions ?? []),
  ...(node.subsections ?? []).flatMap(flattenMyTaskExecutions),
];

/**
 * Convert the recursive `get_my_task_executions` payload into antd tree rows.
 * At every level subsections (expandable section rows) are listed before the
 * section's own task executions (leaf rows) — mirrors the Task Hub tree.
 */
export const buildMyTaskExecutionRows = (
  node: MyTaskExecutionSection
): MyTaskExecutionRow[] => {
  const sectionRows: MyTaskExecutionRow[] = (node.subsections ?? []).map(
    (sub) => ({
      key: `section-${sub.id}`,
      rowType: "section",
      name: sub.name ?? "—",
      total: sub.total_task_executions,
      children: buildMyTaskExecutionRows(sub),
    })
  );

  const taskRows: MyTaskExecutionRow[] = (node.task_executions ?? []).map(
    (te) => ({
      key: `task-${te.id}`,
      rowType: "task",
      name: te.task?.name ?? "—",
      expected: te.timestamp_expected,
      executed: te.timestamp_executed,
      message: te.message,
      priority: te.priority,
      status: te.status,
    })
  );

  return [...sectionRows, ...taskRows];
};
